import { render, staticRenderFns } from "./Collectivites.vue?vue&type=template&id=4326bbb6&"
import script from "./Collectivites.vue?vue&type=script&lang=js&"
export * from "./Collectivites.vue?vue&type=script&lang=js&"
import style0 from "./Collectivites.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports